import React from 'react'
import { sendService } from "../../Services/service";
import Landing from './../../landing/containers/LandingContainer';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Cell, ResponsiveContainer } from 'recharts';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../Actions/Dashboard';
import * as ModalActs from './../../Actions/Modal';

class IepInform extends React.Component {
  state = {
    filterIep: '0',
    ieps: [],
    month: [],
    iep: [],
    neigbor: [],
  }

  domain = (data) => {
    if (data.length === 0)
      return [0, 0];
    let resp = data.reduce((acum, data) => {
      if (acum.value < data.value)
        return data;
      return acum;
    })
    return [0, (parseInt(resp.value * 1.2) + 1)];
  }

  componentDidMount() {
    sendService(`/api/v1/ep/getIep`, "GET").then(value => {
      if (value.status === 200)
        this.setState({ ieps: value.response })
    })
    this.getInformData()
  }

  onHandlerChange = (key, val) => {
    this.setState({ [key]: val }, () => this.getInformData())
  }

  async getInformData() {
    this.props.modalActions.openLoader()
    const resp = await sendService(`/api/v1/ep/getIepInform/${this.state.filterIep}`)
    this.props.modalActions.closeLoader()
    if (resp.status === 200) {
      this.setState({ ...resp.response })
    }
  }

  selectInput(props) {
    return (
      <div className='line line-33'>
        <label>{props.label}</label>
        <div className="div-input-form">
          <select defaultValue={0} value={this.state[props.key]} onChange={(e) => props.onChangeFilter(props.key, e.target.value)} >
            <option value={0}>Todos</option>
            {
              props.keyRef.map(r => <option value={r.key} key={r.userId}>{r.key}</option>)
            }
          </select>
        </div>
      </div>
    )
  }

  bars(props) {
    return (
      <div className='line line-100'>
        <h3 className='text-center primary-color'>{props.title}</h3>
        <ResponsiveContainer height={250}>
          <BarChart data={props.data}
            // margin={{ top: 5, right: 5, left: 5, bottom: 5 }}
            style={{ margin: 'auto' }}
            onClick={this.onClick}>
            <XAxis dataKey="name" fontSize={14} allowDecimals={false} tickMargin={8} />
            <YAxis fontSize={12} allowDecimals={false} domain={this.domain(props.data)} />
            <Tooltip />
            <Bar dataKey="value" fill="#0e6fa5" label={{ position: 'top', fontSize: 14 }} >
              {
                props.data.map((entry, index) => (
                  <Cell key={'cell-bars-' + index} fill="#0e6fa5" />
                ))
              }
            </Bar>
          </BarChart>
        </ResponsiveContainer>

      </div>
    )
  }


  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <div className="content-line">
          <div>
            {this.selectInput({ key: 'filterIep', label: 'Funcionario de espacio público', keyRef: this.state.ieps, onChangeFilter: this.onHandlerChange })}
          </div>
          <hr />
          <div style={{ fontSize: '20px' }}>
            <span className='primary-color' style={{ fontWeight: 700 }}>Funcionario: </span>
            {this.state.filterIep === '0' ? 'Todos' : this.state.filterIep}
          </div>
          <div className='flex-center' style={{ flexDirection: 'column' }}>
            <div><span className='primary-color' style={{ fontWeight: 700 }}>Esta semana: </span>{this.state.thisWeek} Caracterizaciones</div>
            <div><span className='primary-color' style={{ fontWeight: 700 }}>Semana pasada: </span>{this.state.lastWeek} Caracterizaciones</div>
            <div><span className='primary-color' style={{ fontWeight: 700 }}>Este mes: </span>{this.state.thisMonth} Caracterizaciones</div>
            <div><span className='primary-color' style={{ fontWeight: 700 }}>Mes pasado: </span>{this.state.lastMonth} Caracterizaciones</div>
          </div>
          {this.state.filterIep === '0' && this.bars({ title: 'Caracterizaciones X Funcionario', data: this.state.iep })}
          {this.bars({ title: 'Caracterizaciones X Mes', data: this.state.month })}
          {/* {this.bars({ title: 'Caracterizaciones X Barrio', data: this.state.neigbor })} */}
        </div>
      </Landing>
    )
  }
}

function mapStateToProps(state) {
  return {
    session: state.session
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    modalActions: bindActionCreators(ModalActs, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IepInform);